import ZAFClient from 'zendesk_app_framework_sdk';

if (document.getElementById('zendesk-sell-resize')) {
  const zafClient = ZAFClient.init();

  if (zafClient) {
    zafClient.invoke('resize', { width: '100%', height: '700px' });
  }
}
